import tenantTransformers from '@transformers';

const commonApiEndpoints = {
  getActiveProducts: {
    query: (headers) => {
      return {
        url: `/api/surge/products`,
        headers: headers,
      };
    },
    transformer: (response) => {
      return tenantTransformers.productsDataMapper(response);
    },
  },

  getMonthRules: {
    query: () => {
      return {
        url: `/api/surge/packages/custom_package_rules`,
      };
    },
  },

  // Finalized contract per LP-5170. Member route: the Package id is a path param
  // (from the clicked package card), body carries only the five personal fields.
  // BE owns Source = Buy Package Inquiry and Platform = Web; no entry_point is sent.
  submitBuyPackageLead: {
    query: ({ id, ...body }) => {
      return {
        url: `/api/surge/packages/${id}/inquire`,
        method: 'POST',
        body,
      };
    },
  },
};

export default commonApiEndpoints;
